import { URL_GET_ROLEGROUP } from 'constants/urls';

async function getRoleGroupApi() {
	const options = {
		method: 'GET',
		header: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_ROLEGROUP, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
}

export default getRoleGroupApi;
